import * as React from 'react';
import { ReactNode, useState, createContext, useContext, useMemo } from 'react';
import { IStoreInfo } from '../types/IStore';
import { UseState } from '../types/UseStateType';

export interface IStoreInfoContext {
    storeInfo: IStoreInfo | null;
    setStoreInfo: UseState<IStoreInfo | null>;
}

interface IStoreInfoProviderProps {
    children: ReactNode;
}

const StoreInfoContext = createContext<IStoreInfoContext | null>(null);

const StoreInfoProvider: React.FC<IStoreInfoProviderProps> = ({ children }) => {
    const [storeInfo, setStoreInfo] = useState<IStoreInfo | null>(null);

    const values = useMemo(() => ({ setStoreInfo, storeInfo }), [storeInfo]);

    return <StoreInfoContext.Provider value={values}>{children}</StoreInfoContext.Provider>;
};

export function useStoreInfo() {
    const context = useContext(StoreInfoContext);

    if (!context) {
        throw new Error('useStoreInfo has to be used within StoreContextProvider.');
    }

    return context;
}

export default StoreInfoProvider;
